import React, {useCallback, useMemo} from "react";
import {Grid} from '@mui/material'
import SortFilter from '../../SortFilter/SortFilter';
import {filterBySelectOption, sortByFields} from './data';
import useUrlQueryParams from "../../../hooks/useUrlQueryParams";
import useAllLocationNames from "../../../hooks/components/location/useAllLocationNames";
import {useSnackbar} from "../../../context/snackbar-context";

const SupplierBookingFilter = ({
  setQuery
}) => {
  const { snackbarShowMessage } = useSnackbar();
  const locations = useAllLocationNames(snackbarShowMessage);
  const { bookingNumber, locationId: urlLocationId } = useUrlQueryParams();

  const handleCallback = useCallback((e) => {
    setQuery((prevState) => ({
      ...prevState,
      sortBy: e.sortBy,
      selectedLocation: e.location,
      locationId: e.location?.id || '',
      startDate: e.startDate,
      endDate: e.endDate,
      buyerName: e.filters?.find(item => item.name === "buyerName")?.value,
      bookingNumber: e.filters?.find(item => item.name === "bookingNumber")?.value,
      equipmentType: e.selectFilters?.find(item => item.name === "equipmentType")?.value,
      active: e.selectFilters?.find(item => item.name === "active")?.value,
      frequency: e.selectFilters?.find(item => item.name === "frequency")?.value,
      sortDir: e.sortDir
    }));
  },[setQuery]);

  const filterByOptions = useMemo(() => {
    return [
      {
        label: "Buyer Name",
        value: "",
        name: "buyerName",
      },
      {
        label: "Booking Number",
        value: bookingNumber || "",
        name: "bookingNumber",
        numberField: true,
        inputProps: { inputMode: "numeric" }
      }
    ]
  }, [bookingNumber]);

  return (
    <Grid item mb={2} sx={{
      '& .MuiInputLabel-root.Mui-error':{
        color:'rgba(0, 0, 0, 0.6) !important'
      },
      '& .MuiInput-root.Mui-error:before, .MuiInput-root.Mui-error:after':{
        borderBottom: '1px solid rgba(0, 0, 0, 0.42) !important'
      }
    }}>
      <SortFilter
        filterCallback={handleCallback}
        sortByOption={sortByFields}
        locations={locations}
        filterByOption={filterByOptions}
        filterBySelectOption={filterBySelectOption}
        defaultSortBy={sortByFields[2].value}
        sortDir={'desc'}
        locationOption={[]}
        defaultLocationId={urlLocationId || ""}
      />
    </Grid>
  )
}

export default SupplierBookingFilter;
